"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _wdh = require("@demant/wdh");

var moveBaggroundImg = function moveBaggroundImg(cssSelector) {
  var flexspotsElements = (0, _wdh.getAll)(".flex-spot".concat(cssSelector, " .element"));
  flexspotsElements.forEach(function (flexspotElement) {
    var flexspotsImg = flexspotElement.querySelector('[data-tag~="background-image"] img');
    var src = (0, _wdh.resolveImageSrc)(flexspotsImg);

    if (flexspotsImg) {
      flexspotsImg.parentNode.removeChild(flexspotsImg);
      flexspotElement.style.backgroundImage = "url(".concat(src, ")");
    }
  });
};

var movePreElementImg = function movePreElementImg(cssSelector) {
  var flexspots = (0, _wdh.getAll)(".component.flex-spot".concat(cssSelector)); // insert specification to .flex-spot selector

  flexspots.forEach(function (flexspot) {
    var flexspotsPreElementImg = flexspot.querySelector('[data-tag~="pre-element-img"] img');
    var src = (0, _wdh.resolveImageSrc)(flexspotsPreElementImg);

    if (flexspotsPreElementImg) {
      flexspotsPreElementImg.parentNode.removeChild(flexspotsPreElementImg);
      flexspot.style.backgroundImage = "url(".concat(src, ")");
    }
  });
};

var tileAmountHandler = function tileAmountHandler(cssSelector) {
  var removeMissingElements = function removeMissingElements() {
    var hiddenElements = (0, _wdh.getAll)(".flex-spot".concat(cssSelector, " .element.hidden"));
    hiddenElements.forEach(function (hiddenElement) {
      hiddenElement.parentNode.removeChild(hiddenElement);
    });
  };

  var insertMissingElements = function insertMissingElements(flexspot) {
    var flexspotsElements = (0, _wdh.getAll)('.element', flexspot);
    var container = document.querySelector(".flex-spot".concat(cssSelector, " > .component-content"));
    var widthOfContainer = container.offsetWidth;

    var getNumberOfElementsPerRow = function () {
      var elementsPerRow = 0;

      if (widthOfContainer > 1110) {
        elementsPerRow = 4;
      } else if (widthOfContainer <= 1110 && widthOfContainer >= 768) {
        elementsPerRow = 3;
      } else {
        elementsPerRow = 2;
      }

      return elementsPerRow;
    }();

    var numberOfElements = function () {
      var count = flexspotsElements.length;

      if (widthOfContainer > 1110) {
        count += (0, _wdh.getAll)('.element[data-tag~="col-2"]', flexspot).length;
        count += (0, _wdh.getAll)('.element[data-tag~="col-3"]', flexspot).length * 2;
        count += (0, _wdh.getAll)('.element[data-tag~="col-4"]', flexspot).length * 3;
        count += (0, _wdh.getAll)('.element[data-tag~="col-3-row-2"]', flexspot).length * 5;
      } else if (widthOfContainer <= 1110 && widthOfContainer >= 768) {
        count += (0, _wdh.getAll)('.element[data-tag~="col-2"]', flexspot).length;
        count += (0, _wdh.getAll)('.element[data-tag~="col-3"]', flexspot).length;
        count += (0, _wdh.getAll)('.element[data-tag~="col-4"]', flexspot).length * 2;
        count += (0, _wdh.getAll)('.element[data-tag~="col-3-row-2"]', flexspot).length * 5;
      } else {
        count += (0, _wdh.getAll)('.element[data-tag~="col-4"]', flexspot).length;
        count += (0, _wdh.getAll)('.element[data-tag~="col-3-row-2"]', flexspot).length * 3;
      }

      return count;
    }();

    var elementsToInserts = function () {
      var missingElements = getNumberOfElementsPerRow - numberOfElements % getNumberOfElementsPerRow;

      if (missingElements === getNumberOfElementsPerRow) {
        return 0;
      }

      return missingElements;
    }();

    if (window.innerWidth > 850) {
      for (var i = 0; i < elementsToInserts; i += 1) {
        var hiddenDiv = document.createElement('div');
        hiddenDiv.classList.add('element');
        hiddenDiv.classList.add('hidden');
        flexspot.appendChild(hiddenDiv);
      }
    }
  };

  (0, _wdh.onResize)(function () {
    var flexspots = (0, _wdh.getAll)(".flex-spot".concat(cssSelector, " .component-content"));
    flexspots.forEach(function (flexspot) {
      removeMissingElements();
      setTimeout(function () {
        insertMissingElements(flexspot);
      }, 0);
    });
  });
};

var injectComponents = function injectComponents(cssSelector) {
  var elementsWithDataTag = (0, _wdh.getAll)(".component.flex-spot".concat(cssSelector, " .element[data-tag]"));
  elementsWithDataTag.forEach(function (element) {
    var dataTagAttribute = element.getAttribute('data-tag');
    var dataTags = dataTagAttribute.split(' ');
    dataTags.forEach(function (dataTag) {
      if (dataTag !== '') {
        var component = document.querySelector(dataTag);

        if (component) {
          element.innerHTML = '';
          element.appendChild(component);
        }
      }
    });
  });
};

var positionTile = function positionTile(cssSelector) {
  (0, _wdh.getAll)(".flex-spot".concat(cssSelector, " .component-content")).forEach(function (component) {
    var elementToAbsolute = component.querySelector('[data-tag~="col-3-row-2"] + .element + .element');
    var refrenceElement = component.querySelector('[data-tag~="col-3-row-2"] + .element');

    if (elementToAbsolute && refrenceElement) {
      if (window.innerWidth >= 1250) {
        var topPixel = refrenceElement.getBoundingClientRect().top - component.getBoundingClientRect().top + refrenceElement.clientHeight;
        elementToAbsolute.style.position = 'absolute';
        elementToAbsolute.style.top = "".concat(topPixel, "px");
        elementToAbsolute.style.right = 0;
      } else {
        elementToAbsolute.style.position = 'relative';
        elementToAbsolute.style.top = 0;
        elementToAbsolute.style.right = 'auto';
      }
    }
  });
};

var wrapDoubleRowStragglers = function wrapDoubleRowStragglers(cssSelector) {
  (0, _wdh.getAll)(".flex-spot".concat(cssSelector, " .component-content")).forEach(function (component) {
    var doubleRowElement = component.querySelector('[data-tag~="col-3-row-2"]');
    var wrapperElement = component.querySelector('[data-tag~="col-3-row-2"] + .element__wrapper');

    if (doubleRowElement) {
      if (window.innerWidth >= 1250) {
        var upperElement = component.querySelector('[data-tag~="col-3-row-2"] + .element');
        var lowerElement = component.querySelector('[data-tag~="col-3-row-2"] + .element + .element');

        if (!wrapperElement && upperElement && lowerElement) {
          var elementWrapper = document.createElement('div');
          doubleRowElement.parentNode.insertBefore(elementWrapper, upperElement);
          elementWrapper.className = 'element element__wrapper';
          elementWrapper.appendChild(upperElement);
          elementWrapper.appendChild(lowerElement);
        }
      } else if (wrapperElement) {
        var _upperElement = wrapperElement.querySelector('.element');

        var _lowerElement = wrapperElement.querySelector('.element + .element');

        doubleRowElement.parentNode.insertBefore(_upperElement, wrapperElement);
        doubleRowElement.parentNode.insertBefore(_lowerElement, wrapperElement);
        wrapperElement.parentNode.removeChild(wrapperElement);
      }
    }
  });
};

var ebusinessDashboard = function ebusinessDashboard(cssSelector) {
  (0, _wdh.onResize)(function () {
    // positionTile(cssSelector);
    wrapDoubleRowStragglers(cssSelector);
  });

  (function () {
    moveBaggroundImg(cssSelector);
    movePreElementImg(cssSelector);
    tileAmountHandler(cssSelector);
    injectComponents(cssSelector);
  })();
};

var _default = ebusinessDashboard;
exports["default"] = _default;